<template>


  <div class="code-container">
    <div class="code-wrapper">
      <img :src="getAvatarUrl(shareItem)" class="code-avatar">
      <span class="code-username">{{ shareItem[0].map.userName }}</span>
      <span class="code-time">{{ getPassData(shareItem) }}</span>
      <input v-model="inputval" maxlength="4" placeholder="请输入提取码" class="code-input">
      <button :class="checkbtn ? 'code-checkafter' : 'code-checkbefore'" @click="decrypt(shareItem[0].code)">查看文件
      </button>
    </div>
  </div>


</template>

<script>
import {reactive, toRefs, computed} from "vue";
import signUtils from "@/libs/signUtils";
import defaultAvatar from '@/assets/images/tab_mine/avatar/default.png'
import {ElMessage} from "element-plus";
import {validDays} from "@/libs/document";

export default {
  props: {
    shareItem: {
      type: Object,
      require: false,
      default: () => {
        return {}
      }
    }
  },
  emits: ['ShareCodeModelColse'],
  name: "ShareCodeModel",
  setup(props, context) {


    let data = reactive({

      inputval: ''

    })


    let checkbtn = computed(() => {
      return data.inputval.length >= 4
    })


    function decrypt(code) {
      if (checkbtn.value) {
        if (signUtils.decryptHex(code) == data.inputval) {
          context.emit('ShareCodeModelColse',data.inputval)
        } else {
          ElMessage({
            message: '请输入正确提取码',
            type: 'warning',
            center: 'center'
          })
        }
      }
    }

    function getAvatarUrl(item) {
      let avatar = item[0].map.avatar
      if (avatar == undefined)
        return defaultAvatar
      if (avatar.indexOf('assets') != 0) {
        return avatar
      } else {
        let url = avatar.slice(0, avatar.lastIndexOf('.'))
        return require('@/' + `${url}` + '.png')
      }
    }

    function getPassData(shareItem) {
      if (shareItem[0].term == -1)
        return '一次性'
      else
        return shareItem[0].term == 0 ? '永久有效' : validDays(shareItem[0].updTime,shareItem[0].term)+ '天后过期'
    }


    return {
      checkbtn,
      getPassData,
      getAvatarUrl,
      decrypt,
      ...toRefs(data)
    }

  }
}
</script>

<style scoped>

.code-container {
  flex: 1;
  display: flex;
  justify-content: center;
}

.code-wrapper {
  margin-top: 145px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 440px;
  height: 515px;
  background-image: url("@/assets/images/share/pc-code-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.code-avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin-top: 70px;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.code-username {
  font-size: 17px;
  margin-top: 35px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.code-time {
  margin-top: 20px;
  font-size: 14px;
  color: #909399;
}

.code-input {
  width: 250px;
  height: 50px;
  margin-top: 40px;
  border: none;
  outline: none;
  border-radius: 7px;
  text-indent: 20px;
  caret-color: #39D5E3;
  background-color: #F3F3F3;
}

.code-checkbefore {
  width: 250px;
  height: 48px;
  margin-top: 40px;
  border: none;
  outline: none;
  color: #0982FE;
  background-color: #DAECFF;
  border-radius: 10px;
}

.code-checkafter {
  width: 250px;
  height: 48px;
  margin-top: 40px;
  border: none;
  outline: none;
  background-color: #0982FE;
  color: #FFFFFF;
  border-radius: 10px;
}

</style>
